import React, {
	useState,
	useEffect,
	useRef,
	useLayoutEffect,
	useContext,
	Suspense,
} from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaAngleLeft } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { SearchContext } from './Contexts/Context';
import { getAparatiSakrebulo, getPages, getStaticPageBySlug } from '../service/service';
function Default() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [api, setApi] = useState({});

	const [parent, setParent] = useState();
	const [istoriebi, setIstoriebi] = useState({});
	const [prescentri, setPrescentri] = useState({});
	const [exactParent, setExactParent] = useState([]);
	const [itself, setItself] = useState([]);
	const [width, setWidth] = useState(10);
	const { language } = useContext(SearchContext);
	const ref = useRef(null);
	const [page, setPage] = useState([]);
	const [item, setItem] = useState([]);
	const [load, setLoad] = useState(false);
	const [filtered, setFiltered] = useState([]);
	const [khuloIstoria, setKhuloIstoria] = useState([]);
	const [personalOfficer, setPersonalOfficer] = useState([]);


//khulos istoria
	useEffect(()=>{
		const fetchData = async () => {
			const data = await getStaticPageBySlug('xulos-shesaxeb');
			setKhuloIstoria(data);
		}
		fetchData();
	},[]);


	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});
		useLayoutEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				// console.log(data)
				setPrescentri(data.menu);
				Object.entries(data.menu).map((item, index) => {
					if (item[1].slug == id) {
						setApi(item[1].content_id);
						setParent(item[1].parent_id);

						// console.log('item',item)
						const apiLink = `https://khulo.gov.ge/api/get_content.php?content_id=${item[1].content_id}`;
						fetch(apiLink)
							.then(res => res.json())
							.then(dat => {
								setIstoriebi(dat);
								Object.entries(data.menu).map((qveitem, index) => {
									if (qveitem[1].cat_id == item[1].parent_id) {
										//  console.log(item)
										setExactParent(qveitem);
										setItself(item);
									}
								});
							});
					}
				});
				//   setApi(data.menu[338].content_id)

				// console.log('data.menu[1] api' , data.menu[338].content_id)
				//  console.log('menu', menu)

				//  console.log('object entries', Object.entries(menu))
				// console.log(istoriebi)
			});
	}, []);

	const presscenterList =
		exactParent.length && Object.entries(prescentri).length
			? Object.entries(prescentri).map((item, index) => {
					if (
						item[1].level == 1 &&
						item[1].name_geo == exactParent[1].name_geo
					) {
						return Object.entries(prescentri).map((qveItem, index) => {
							if (qveItem[1].parent_id == item[1].cat_id) {
								const windoww = window.location.pathname;
								const result = windoww.split('/').pop();
								const slugg = qveItem[1].slug;
								return (
									<span
										key={index}
										className={result === slugg ? 'active' : ''}
									>
										<Link to={`/${qveItem[1].slug}`}>
											{language == 1 ? qveItem[1].name_geo : ''}
											{language == 2 ? qveItem[1].name_eng : ''}
											{language == 3 ? qveItem[1].name_ru : ''}
										</Link>
									</span>
								);
							}
						});
					}
			  })
			: '';
	const getDefaultPage = async () => {
		await getPages().then(data => {
			if (id === 'pasukhismgebeli-pirebi') {
				setPage(data[0]);
			}
			if (id === 'sakrebulos-shesaxeb') {
				setPage(data[1]);
			}
			if (id === 'droebiti-jgufebi') {
				setPage(data[2]);
			}
		});
	};


	useEffect(() => {
		getDefaultPage();
	}, []);

	const aparati = async () => {
		await getAparatiSakrebulo().then(data => {
			setItem(data);
		});
	};

	useEffect(() => {
		aparati();
	}, []);

	//oficer
useEffect(()=>{
		const fetchData = async () => {
			const data = await getStaticPageBySlug('personalur-monacemta-dacvis-oficeri');
			setPersonalOfficer(data);
		
		}
		fetchData();
	},[]);

	useEffect(() => {
		if (id === 'sashtato-nuskha') {
			setPage(item[1]);
		}
		if (id === 'khulos-shesakheb') {
			setPage(khuloIstoria);
		}
		if(id === 'dacvis-oficeri-meria'){
			setPage(personalOfficer);
		}
		setLoad(true);
	}, [item]);

	const DefaultPageView = () => {
	
		return (
			<div className='istoria'>
				<div className={`sakrebulo-landing-paragraphs `}>
					<span
						dangerouslySetInnerHTML={{
							__html:
								  page?.description
									? page?.description
											.replaceAll('../', 'https://khulo.gov.ge/')
											.replaceAll('<img', '<img tabIndex="-1"')
									: page?.content || '...',
						}}
						style={{
							display: id == 'sakrebulos-shesaxeb' ? 'block' : 'flex',
						}}
					></span>
				</div>
				<div className='share'>
					<span className='back' onClick={() => navigate(-1)}>
						<div>
							<FaAngleLeft />
						</div>
						{language == 1 ? ' უკან დაბრუნება' : ''}
						{language == 2 ? 'return Back' : ''}
						{language == 3 ? 'вернуться обратно' : ''}
					</span>
					<span>
						{language == 1 ? '   გააზიარე:' : ''}
						{language == 2 ? 'SHARE:' : ''}
						{language == 3 ? 'Поделиться:' : ''}

						<FacebookShareButton
							url={window.location.href}
							quote='satesto quote'
							title='satesto title'
						>
							<FaFacebookF />
						</FacebookShareButton>
						<TwitterShareButton url={window.location.href}>
							<FaTwitter />
						</TwitterShareButton>
					</span>
				</div>
			</div>
		);
	};

function BigSpinner() {
  return <h2>🌀 Loading...</h2>;
}

	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span
						className='big '
						id='meria'
						ref={ref}
						style={{ marginRight: width / 2 }}
					>
						{exactParent.length ? language == 1 && exactParent[1].name_geo : ''}
						{exactParent.length ? language == 2 && exactParent[1].name_eng : ''}
						{exactParent.length ? language == 3 && exactParent[1].name_ru : ''}
					</span>
					<span>{page ? page.title : 'Loading'}</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container flex'>
							{<Suspense fallback={<BigSpinner />}>
							<DefaultPageView />
							</Suspense>  }
						</div>
					</div>
					<div className='presscenter-info'>{presscenterList}</div>
				</div>
			</div>
		</motion.div>
	);
}

export default Default;
